/* eslint jsx-a11y/aria-activedescendant-has-tabindex: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import NavTabBarButton from './NavTabBarButton/NavTabBarButton';

import { ReactComponent as IconJourneyPlan } from '../../assets/svg/journeyplanner.svg';
import { ReactComponent as IconLiveDepartures } from '../../assets/svg/livedeparture.svg';
import { ReactComponent as IconTimeTables } from '../../assets/svg/timetable.svg';
import { TABS } from '../../services/NavigationService';
import { Keyboard } from '../../utils/Keyboard';

class NavTabBar extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.tabsOrdered = [TABS.JOURNEY_PLANNER, TABS.LIVE_DEPARTURES, TABS.TIMETABLES];
  }

  _createTab = (selectedTab) => {
    const { history } = this.props;
    switch (selectedTab) {
      case TABS.JOURNEY_PLANNER:
        this.jpRef.focus();
        history.push(TABS.JOURNEY_PLANNER);
        break;
      case TABS.TIMETABLES:
        this.ttRef.focus();
        history.push(TABS.TIMETABLES);
        break;
      case TABS.LIVE_DEPARTURES:
      default:
        this.ldRef.focus();
        history.push(TABS.LIVE_DEPARTURES);
    }
  };

  _getCurTabIndex = () => {
    const { history } = this.props;
    const pathname = history?.location?.pathname;
    return this.tabsOrdered.findIndex(tab => pathname?.startsWith(tab));
  };

  _switchTabOnKeyDown = (ev) => {
    const curIndex = this._getCurTabIndex();
    let nextIndex;
    switch (ev.keyCode) {
      case Keyboard.ARROW_RIGHT:
        nextIndex = (curIndex + 1) % this.tabsOrdered.length;
        this._createTab(this.tabsOrdered[nextIndex]);
        ev.stopPropagation();
        break;
      case Keyboard.ARROW_LEFT:
        nextIndex = (curIndex <= 0) ? this.tabsOrdered.length - 1 : curIndex - 1;
        this._createTab(this.tabsOrdered[nextIndex]);
        ev.stopPropagation();
        break;
      default:
        break;
    }
  };

  render() {
    const { history } = this.props;
    const pathname = history?.location?.pathname;

    const isJourneyPlanner = pathname?.startsWith(TABS.JOURNEY_PLANNER);
    const isLiveDepartures = pathname?.startsWith(TABS.LIVE_DEPARTURES);
    const isTimetables = pathname?.startsWith(TABS.TIMETABLES);
    const curTabIndex = this._getCurTabIndex();
    return (
      <main className="at-flex-grid">
        <div className="container-fluid">
          <div className="row nav-bar" role="tablist" onKeyDown={this._switchTabOnKeyDown} tabIndex={-1} aria-activedescendant={`nav-tab-bar-${curTabIndex}`}>
            <NavTabBarButton
              className="col-xs-4"
              title="Journey planner"
              description="Plan a new journey"
              selected={isJourneyPlanner}
              onClick={() => this._createTab(TABS.JOURNEY_PLANNER)}
              onKeyDown={this._switchTabOnKeyDown}
              SvgIcon={IconJourneyPlan}
              divId="nav-tab-bar-1"
              externalRef={(ref) => { this.jpRef = ref; }}
              tabIndex={curTabIndex === 0 ? 0 : -1}
            />
            <NavTabBarButton
              className="col-xs-4 nav-tab-bar-button-left"
              title="Live departures"
              description="Get departures in real time"
              selected={isLiveDepartures}
              onClick={() => this._createTab(TABS.LIVE_DEPARTURES)}
              onKeyDown={this._switchTabOnKeyDown}
              SvgIcon={IconLiveDepartures}
              divId="nav-tab-bar-0"
              externalRef={(ref) => { this.ldRef = ref; }}
              tabIndex={curTabIndex === 1 ? 0 : -1}
            />
            <NavTabBarButton
              className="col-xs-4 nav-tab-bar-button-right"
              title="Timetables"
              description="Find and download timetables"
              selected={isTimetables}
              onClick={() => this._createTab(TABS.TIMETABLES)}
              onKeyDown={this._switchTabOnKeyDown}
              SvgIcon={IconTimeTables}
              divId="nav-tab-bar-2"
              externalRef={(ref) => { this.ttRef = ref; }}
              tabIndex={curTabIndex === 2 ? 0 : -1}
            />
          </div>
        </div>
      </main>
    );
  }
}

export default NavTabBar;